import React from 'react';

function Hero() {
  return (
    <section id="home" className="hero">
      <div className="hero-content">
        <h2>Conrad Tutoring: Meeting the New Standard</h2>
        <p>
          COVID-era grading changes have made it harder to achieve an A. Conrad Tutoring helps you excel with personalized, data-driven sessions, measurable results, and a proven track record. Start your journey to academic success today!
        </p>
        <a href="#contact" className="cta-button">Get Your First Session Free</a>
      </div>
    </section>
  );
}

export default Hero;
